import React, { ReactNode } from 'react';

import { FileDescriptionBlock } from '../../components/FileDescriptionBlock';
import { PayFitColor } from '../../types/module';
import { applyBgColor } from '../../utils/utils';
import { classNames } from '../../utils/style';
import { Image } from '../../components/Image';
import { textSerifTitle2 } from '../../styles/typography';
import { container } from '../../styles/themes';
import './hubspot.scss';
import { ImageProps } from '../../components/Image/types';
export interface HeroFormProps {
  backgroundColor: PayFitColor;
  className: string;
  children: ReactNode;
  file: {
    editDate: Date;
    format: string;
    locale: 'en' | 'es' | 'fr';
    writer: {
      genre: 'woman' | 'man';
      name: string;
    };
  };
  form: ReactNode;
  picture?: ImageProps;
  title: string;
}

export const HeroForm = ({
  backgroundColor,
  className,
  children,
  file,
  form,
  picture,
  title,
}: HeroFormProps) => {
  return (
    <section
      className={classNames(
        'HeroForm',
        'pt-[64px] pb-[64px',
        'md:pt-[104px] md:pb-[104px]',
        'overflow-hidden',
        applyBgColor(backgroundColor),
        className,
      )}
      id="payfit-HeroForm"
    >
      <div
        className={classNames(
          container,
          'flex flex-col items-center gap-x-24 lg:flex-row',
        )}
      >
        <div
          className={classNames(
            'max-w-[600px] w-full lg:max-w-[483px]',
            'xl:max-w-[736px]',
          )}
        >
          <h1
            className={classNames(
              textSerifTitle2,
              'mb-24 text-center lg:text-left',
            )}
          >
            {title}
          </h1>
          <div className="hidden lg:block">
            {picture && <Image {...picture} className="rounded-6 w-full" sizes={['400px']} />}
            {children}
          </div>
          <FileDescriptionBlock {...file} className="hidden mt-32 lg:flex" />
        </div>
        <div
          className={classNames(
            'p-40 shadow-xl lg:min-w-600',
            'rounded-18 bg-neutral-1',
          )}
        >
          {form}
        </div>
        <FileDescriptionBlock {...file} className="mt-32 lg:hidden" />
      </div>
    </section>
  );
};
